export const READINESS_STATUS = {
  Ready: 'Ready',
  AlmostReady: 'AlmostReady',
  NeedsWork: 'NeedsWork',
};

const READINESS_STATUS_MAPPING = [
  { value: READINESS_STATUS.Ready, label: 'Ready', countKey: 'ready', color: '#4CAF50' },
  {
    value: READINESS_STATUS.AlmostReady,
    label: 'Almost Ready',
    countKey: 'almostReady',
    color: '#FF9800',
  },
  {
    value: READINESS_STATUS.NeedsWork,
    label: 'Needs Work',
    countKey: 'needsWork',
    color: '#F44336',
  },
];

export const getReadinessStatusLabel = value =>
  READINESS_STATUS_MAPPING.find(item => item.value === value)?.label || 'Needs Work';

export const getReadinessStatusColor = value =>
  READINESS_STATUS_MAPPING.find(item => item.value === value)?.color || '#F44336';

export const getReadinessStatusCountKey = value =>
  READINESS_STATUS_MAPPING.find(item => item.value === value)?.countKey || 'needsWork';
